const spinnerOn = () => {
    const spinner = document.getElementById('spinner');
    spinner.classList.remove('d-none');
    const spinnerBackground = document.getElementById('spinnerBackground');
    spinnerBackground.classList.remove('d-none');
}

const spinnerOff = () => {
    spinner.classList.add('d-none');
    spinnerBackground.classList.add('d-none');
}

export {
    spinnerOn,
    spinnerOff
}
